export default __webpack_public_path__ + "static/media/downloadButtonResume.02af74fe.webp";